import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

// ローカルストレージから言語設定を取得（デフォルト: 日本語）
const getStoredLanguage = () => {
  try {
    return localStorage.getItem('language') || 'ja';
  } catch (error) {
    return 'ja';
  }
};

i18n.use(initReactI18next).init({
  resources: translations,
  lng: getStoredLanguage(), // 保存された言語設定を使用
  fallbackLng: 'ja', // フォールバック言語
  debug: false, // デバッグモードを無効（本番環境対応）
  
  interpolation: {
    escapeValue: false, // React では XSS 対策が不要
  },
  
  react: {
    useSuspense: false, // Suspense を使用しない（安定性向上）
    bindI18n: 'languageChanged', // 言語変更時の再レンダリング
    bindI18nStore: '', // ストア変更時の再レンダリングを無効
  },

  // キャッシュとパフォーマンス設定
  saveMissing: false, // 未翻訳キーを保存しない
  keySeparator: '.', // キーの区切り文字
  nsSeparator: false, // 名前空間区切り文字を無効
});

// 言語変更時にローカルストレージを更新
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('language', lng);
    // ページタイトルも更新（必要に応じて）
    document.documentElement.lang = lng;
  } catch (error) {
  }
});

export default i18n;
